<template>
    <div id="workspaces-view">
        <!-- Link back to homepage -->
        <router-link to="/" v-if="Object.keys(workspaces).length" class="backlink-home">
            &lt;-- Home
        </router-link>

        <h1>Manage Workspaces</h1>

        <div id="workspaces-list">
            <div v-for="workspace in workspaces" :key="'workspace' + workspace.slug" class="workspace-list-item">
                {{workspace.name}}
                <div :class="{'icon-button danger': 1, 'disabled': (workspace.slug === current_workspace.slug || workspace.slug === 'documentation')}" @click="deleteWorkspace(workspace)">
                    <i class="fas fa-trash-alt"/>
                </div>
            </div>

            <div v-if="adding_workspace" id="new_workspace" class="workspace-list-item fake" @keydown.enter="addWorkspace">
                <input type="text" id="new_workspace_input" ref="workspace_name_input" v-model="new_workspace_name" placeholder="New Workspace Name"/>
                <div class="icon-button save-button" @click="addWorkspace">
                    <i class="fas fa-check"/>
                </div>
            </div>

            <div id="add-workspace-button" class="workspace-list-item">
                <div class="icon-button" @click="toggleAddWorkspace">
                    <i class="fas fa-plus"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            errors: [],
            adding_workspace: false,
            new_workspace_name: null,
            show_info: false,
        }
    },
    methods: {
        addWorkspace() {
            if (!this.new_workspace_name) return;

            try {
                let showinfo = (Object.keys(this.workspaces).length === 0);

                this.$store.dispatch('addWorkspace', this.new_workspace_name);
                this.new_workspace_name = null;
                this.adding_workspace = false;
                this.show_info = true;
            } catch (e) {
                this.errors.push(e);
            }
        },

        deleteWorkspace(workspace) {
            this.$store.dispatch('deleteWorkspace', workspace);
        },

        toggleAddWorkspace() {
            this.adding_workspace = !this.adding_workspace;
            if (this.adding_workspace) this.$nextTick(() => {this.$refs.workspace_name_input.focus()});
        }
    },
    computed: {
        current_workspace () {
            return this.$store.getters.current_workspace;
        },

        workspaces () {
            return this.$store.getters.workspaces;
        },
    }
}
</script>

<style lang="sass">
    @import '../assets/colors.sass';
    #workspaces-view
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        h1
            margin: 0;

    #workspaces-list
        width: 100%;
        padding: 0 40px;
        display: flex;
        flex-direction: column;

    .workspace-list-item
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-between;
        padding: 10px;
        align-items: center;

        &:nth-child(odd)
            background-color: $darker-bg;

    .workspace-list-item.fake
        padding-left: 0;
        padding-right: 0;
            
    
    
    .save-button
        margin-left: 5px;
    .icon-button.save-button:hover
        background-color: $green;
        border-color: lighten($green, 10%);
    .icon-button.save-button:active
        background-color: darken($green, 10%);
    

    #add-workspace-button
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;

    .backlink-home
        text-align: left;
        width: 100%;
        padding: 10px 15px;
</style>
